module.exports = __webpack_public_path__ + "media/images/prof_ellipse-c922ba0afc39d1bc1a6e66c6be6e0d92.png";